import { WSElement } from "@wingspanhq/fe-component-library";
import { Payer, PayerEngagement } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { selectorCounterpartyDisplayName } from "../../../shared/selectors/selectorCounterpartyDisplayName";
import { DataView } from "../../../shared/components/DataView";

type Props = {
  shimmer?: boolean;
  payer?: Payer;
  payerPayeeEngagement?: PayerEngagement;
};

export const WorkLogEngagementDetails: React.FC<Props> = props => {
  const engagementPreview = useMemo(() => {
    if (!props.payer) {
      return;
    }
    if (!props.payerPayeeEngagement) {
      return;
    }

    return {
      name: selectorCounterpartyDisplayName(props.payer),
      company: props.payer.profile?.company?.doingBusinessAs,
      email: props.payer.email,
      engagementName: props.payerPayeeEngagement.engagementName
    };
  }, [props.payer, props.payerPayeeEngagement]);

  return (
    <WSElement>
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Contact name",
            value: engagementPreview?.name
          },
          {
            label: "Client company",
            value: engagementPreview?.company
          },
          {
            label: "Contact email",
            value: engagementPreview?.email
          },
          {
            label: "Assignment name",
            value: engagementPreview?.engagementName
          }
        ]}
      />
    </WSElement>
  );
};
